import Announcement, { Component } from './Announcement';

export default Announcement;
export {
  Component,
};
